<script lang="jsx">
import { caseOf } from "../lib";
import ErrorBlock from "./ErrorBlock";

const FormActions = ({ status, reset, messages, html }) => {
    return [
      caseOf(status, {
        Idle: () => null,
        Processing: () => null,
        Saved: () => <div class="success">{messages.saved}</div>,
        Updated: () => <div class="success">{messages.updated}</div>,
        Failed: () => <ErrorBlock error={messages.error} />
      }),

      <div>
        {html && html}
        { reset && <input type="reset" value="Reset" onClick={reset} /> }
        {caseOf(status, {
          Processing: () => (
            <button class="success" disabled>
              <div class="spinner" />
            </button>
          ),
          _: () => <button class="success">Save</button>
        })}
      </div>
    ];
};
export default FormActions;
</script>
